import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  imageId: string;
  episodeId: string;
  isChildPresented: boolean;
  onUpload: (
    imageId: string,
    episodeId: string,
    imageFile: File,
    maskFile?: File,
  ) => void;
  isUploading?: boolean;
};

export function ManualImageUploadDialog({
  open,
  onClose,
  imageId,
  episodeId,
  isChildPresented,
  onUpload,
  isUploading,
}: Props) {
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [maskFile, setMaskFile] = useState<File | null>(null);

  const handleClose = () => {
    setImageFile(null);
    setMaskFile(null);
    onClose();
  };

  const handleSubmit = () => {
    if (!imageFile) {
      return;
    }
    if (isChildPresented && !maskFile) {
      return;
    }
    onUpload(imageId, episodeId, imageFile, maskFile || undefined);
  };

  const isValid = imageFile && (!isChildPresented || maskFile);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload Manually Edited Image</DialogTitle>
      <DialogContent>
        <Stack gap={3} sx={{ mt: 1 }}>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Image File *
            </Typography>
            <Button variant="outlined" component="label" fullWidth>
              {imageFile ? imageFile.name : "Choose Image File"}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) setImageFile(file);
                }}
              />
            </Button>
          </Box>

          {isChildPresented && (
            <>
              <Typography variant="subtitle2">
                {" "}
                User Character Present in the Image. Please upload a mask too
              </Typography>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Mask File *
                </Typography>
                <Button variant="outlined" component="label" fullWidth>
                  {maskFile ? maskFile.name : "Choose Mask File"}
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) setMaskFile(file);
                    }}
                  />
                </Button>
              </Box>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isUploading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!isValid || isUploading}
        >
          {isUploading ? "Uploading..." : "Upload"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
